export const CHAT_TYPES = {
  private: 'Private',
  group: 'Group',
};

export default {};
